
import React, { useEffect, useState } from 'react';
import { LoaderMini } from '~/components/Loaders';
import { Button, Col, Row } from 'reactstrap';
import EsteiraComponent from './EsteiraComponent';
import AutoTabInputs from './AutoTabInputs';
/* eslint-disable */


function Terceiro(props) {
	const {
		getNewCode,
		loading,
		timer,
		setTimer,
		step,
		setStep,
		typeSelected,
		setTypeSelected,
		setSubTitle,
		verifyCode,
		inputValues,
		setInputValues,
		errorMessage,
		setErrorMessage
	} = props;

	const [seconds, setSeconds] = useState(180);


	useEffect(() => {
		if (seconds === 0) {
		  setErrorMessage("Tempo esgotado. Tente reenviar o código novamente.");
		  setTimer({
			...timer,
			active: false,
		  });
		}

		if (timer.active && seconds > 0) {
		  const intervalId = setInterval(() => {
			setSeconds(prevSeconds => prevSeconds - 1);
			setTimer({
			  ...timer,
			  minute: Math.floor((seconds - 1) / 60),
			  seconds: (seconds - 1) % 60,
			});
		  }, 1000);

		  return () => clearInterval(intervalId);
		}
	  }, [seconds, timer.active]);

	useEffect(() => {
		setSeconds(180);
	}, [])

	return (
		<div className="content-center">
			<div className="d-flex flex-column align-items-start mt-4">
				<span style={{fontSize: '14px'}}>Validar Token</span>
				<AutoTabInputs
					values={inputValues}
					setValues={setInputValues}
					errorMessage={errorMessage}
					setErrorMessage={setErrorMessage}
			 	/>
				{errorMessage &&
					<div style={{fontSize: '14px', color: 'red', marginBottom: '20px'}} className="w-100 d-flex align-items-center"> <i>{errorMessage}</i></div>
				}
				<div className="w-100 d-flex justify-content-between">
					<div style={{fontSize: '14px', cursor: 'pointer'}}
					onClick={() => {
						getNewCode(typeSelected);
						setSeconds(180);
						setInputValues({ input1: '', input2: '', input3: '', input4: '', input5: '', input6: '' });
						}}
					>Reenviar código</div>
					<span style={{fontSize: '14px', marginRight: '5px'}}><b>Tempo: </b>{`${timer.minute < 10 ? '0' + parseInt(timer.minute) : timer.minute}m:${ timer.seconds < 10 ? '0' + parseInt(timer.seconds) : timer.seconds}s` || '0m:0s'}</span>
				</div>
			</div>


			<Row className="rowButton px-4 w-100">
				<Col>
					<Button
						color="primary"
						disabled={
							inputValues.input1== '' ||
							inputValues.input2== '' ||
							inputValues.input3== '' ||
							inputValues.input4== '' ||
							inputValues.input5== '' ||
							inputValues.input6== '' ||
							!timer.active
							}
						className="buttonComponent px-5"
						onClick={() => {
							verifyCode()
						}}>

						{!loading ? 'VERIFICAR' : <LoaderMini width="20" /> }
					</Button>
				</Col>
			</Row>
			<EsteiraComponent step={step} />


			<Row className="rowButton w-100">
				<Col>
					<Button
						outline
						color="primary"
						className="buttonComponentOutline"
						onClick={() => {
							setTypeSelected('')
							setStep(2)
							setSubTitle('')
							setInputValues({ input1: '', input2: '', input3: '', input4: '', input5: '', input6: '' })
						}}>
						VOLTAR
					</Button>
				</Col>
			</Row>
		</div>
	);
}

export default Terceiro;
